module.exports = __webpack_public_path__ + "img/105.8f978412.jpg";